import React, { ReactNode, forwardRef } from 'react'
import { default as AntdSelect } from 'antd/lib/select'
import { ConfigConsumer } from 'antd/lib/config-provider'
import type { SelectProps as AntdSelectProps } from 'antd/lib/select'
import classNames from 'classnames'
import { get } from 'lodash'
import { connectReadonlyComponent } from '../connect'
import PreviewText from '../preview-text'

export interface SelectProps extends AntdSelectProps {
  // 线框风格
  borderStyle?: 'outline'
  children?: ReactNode
  options?: Array<
    | string
    | number
    | {
        label: string
        value: string | number
        disabled?: boolean
      }
  >
  fieldNames?: {
    label?: string
    value?: string
    options?: string
  }
  readonly?: boolean
}

interface SelectComponent
  extends React.ForwardRefExoticComponent<SelectProps & React.RefAttributes<AntdSelect>> {
  OptGroup: typeof AntdSelect.OptGroup
  Option: typeof AntdSelect.Option
}

const { Option } = AntdSelect

export const InternalSelect = forwardRef<AntdSelect, SelectProps>(
  ({ className, borderStyle, options, fieldNames, children, ...props }, ref) => (
    <ConfigConsumer>
      {({ getPrefixCls }) => {
        const prefixCls = getPrefixCls('select')

        return (
          <AntdSelect
            {...props}
            className={classNames(className, {
              [`${prefixCls}-outline`]: borderStyle === 'outline',
            })}
            ref={ref}
          >
            {children
              ? children
              : options?.map((option) => {
                  if (typeof option === 'object') {
                    return (
                      <Option
                        key={get(option, fieldNames?.value || 'value')}
                        value={get(option, fieldNames?.value || 'value')}
                        disabled={!!option.disabled}
                      >
                        {get(option, fieldNames?.label || 'label')}
                      </Option>
                    )
                  }

                  return (
                    <Option key={option} value={option}>
                      {option}
                    </Option>
                  )
                })}
          </AntdSelect>
        )
      }}
    </ConfigConsumer>
  )
) as SelectComponent

export const Select = connectReadonlyComponent(
  InternalSelect,
  PreviewText.Select
) as SelectComponent

Select.OptGroup = AntdSelect.OptGroup
Select.Option = AntdSelect.Option
